import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/Common/withRouter';


//import Components
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

import { useLayoutStore } from "../stores/useLayoutStore";

const Layout = (props: any) => {
    const [headerClass, setHeaderClass] = useState("");
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        preloader,
        sidebarVisibilitytype,
        changeLayout,
        changeSidebarTheme,
        changeLayoutMode,
        changeLayoutWidth,
        changeLayoutPosition,
        changeTopbarTheme,
        changeLeftsidebarSizeType,
        changeLeftsidebarViewType,
        changeSidebarVisibility,
    } = useLayoutStore();
    // class add remove in header
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });
    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }
    /*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            sidebarVisibilitytype ||
            leftSidebarImageType ||
            preloader
        ) {
            window.dispatchEvent(new Event('resize'));
            changeLeftsidebarViewType(leftSidebarViewType);
            changeLeftsidebarSizeType(leftsidbarSizeType);
            changeSidebarTheme(leftSidebarType);
            changeLayoutMode(layoutModeType);
            changeLayoutWidth(layoutWidthType);
            changeLayoutPosition(layoutPositionType);
            changeTopbarTheme(topbarThemeType);
            changeLayout(layoutType);
            changeSidebarVisibility(sidebarVisibilitytype);
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        sidebarVisibilitytype,
        leftSidebarImageType,
        preloader,
        changeLayout,
        changeLayoutMode,
        changeLayoutPosition,
        changeLayoutWidth,
        changeLeftsidebarSizeType,
        changeLeftsidebarViewType,
        changeSidebarTheme,
        changeSidebarVisibility,
        changeTopbarTheme]);

    // Sync theme + sidebar to DOM when mode/sidebar type change (fix sidebar not updating)
    useEffect(() => {
        document.documentElement.setAttribute("data-bs-theme", layoutModeType);
        document.body.setAttribute("data-bs-theme", layoutModeType);
        document.documentElement.setAttribute("data-sidebar", leftSidebarType);
        document.body.setAttribute("data-sidebar", leftSidebarType);
    }, [layoutModeType, leftSidebarType]);
    /*
    call dark/light mode
    */
    const onChangeLayoutMode = (value: any) => {
        if (changeLayoutMode) {
            changeLayoutMode(value);
        }
    };

    useEffect(() => {
        if (sidebarVisibilitytype === 'show' || layoutType === "vertical" || layoutType === "twocolumn") {
            document.querySelector(".hamburger-icon")?.classList.remove('open');
        } else {
            document.querySelector(".hamburger-icon")?.classList.add('open');
        }
    }, [sidebarVisibilitytype, layoutType]);

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header
                    headerClass={headerClass}
                    layoutModeType={layoutModeType}
                    onChangeLayoutMode={onChangeLayoutMode} />
                <Sidebar layoutType={layoutType} />
                <div className="main-content">{props.children}
                    <Footer />
                </div>
            </div>
        </React.Fragment>
    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);